export default "__VITE_ASSET___DS4X21Z__"